export default {
  selectCategoryTitle: {
    id: 'create_pricing_rule_select_category_title',
    defaultMessage: '1. Select a product category',
  },
  selectCategoryLabel: {
    id: 'create_pricing_rule_select_category_label',
    defaultMessage: 'Category',
  },
  allCategories: {
    id: 'create_pricing_rule_select_all_categories',
    defaultMessage: 'All categories',
  },
  ruleTitle: {
    id: 'create_pricing_rule_define_rule_title',
    defaultMessage: '2. Define a rule for this category',
  },
  rulePrice: {
    id: 'create_pricing_rule_define_rule_price',
    defaultMessage: '{country} price',
  },
  ruleMultiplier: {
    id: 'create_pricing_rule_define_rule_multiplier',
    defaultMessage: 'Multiplier',
  },
  ruleOffset: {
    id: 'create_pricing_rule_define_rule_offset',
    defaultMessage: 'Fixed amount',
  },
  ruleCalculation: {
    id: 'create_pricing_rule_define_rule_calculation',
    defaultMessage:
      'If the price in {reference_country} is {reference_price}, the price in {target_country} will be {target_price}',
  },
  warningPriceMessage: {
    id: 'create_pricing_rule_warning_price_message',
    defaultMessage: 'Warning: your prices will vary by more than 20%!',
  },
  ruleHelpText: {
    id: 'create_pricing_rule_define_rule_help_text_new',
    defaultMessage:
      'For your listings within the selected scope, your prices in {target_country} will be calculated on the basis of your prices in {reference_country} and the formula specified.',
  },
  addRule: {
    id: 'create_pricing_rule_add_rule',
    defaultMessage: 'Add this rule',
  },
  editRule: {
    id: 'create_pricing_rule_edit_rule',
    defaultMessage: 'Save the modification',
  },
  cancel: {
    id: 'create_pricing_rule_cancel',
    defaultMessage: 'Cancel',
  },
}
